/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

import createStrictShapeTypeChecker from '../../modules/createStrictShapeTypeChecker';
import { number } from 'prop-types';

var PointPropType = createStrictShapeTypeChecker({
  x: number,
  y: number
});

export default PointPropType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/exports/PointPropType/index.js
// module id = 1025
// module chunks = 0